module.exports = __webpack_public_path__ + "static/media/otellu-icon-v1.e515b34e.svg";